import React from 'react'
import img2 from '../images/map.webp'
import img3 from '../images/location_bg.webp'
import img4 from '../images/location.webp'
import { Container, Row, Col } from 'react-bootstrap'
import { useMediaQuery } from 'react-responsive'

const Location = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 991px)' });
  return (
    <div className='location-section py-50 position-relative' id='location'>
      <Container>
        <h2 className='mb-2'>Prime Location With Seamless Connectivity</h2>
        <h6 className='mb-5'>Strategically located in Kollur, IRA Miracle Ensures You Stay Connected To The City While Enjoying The Tranquility Of A Residential Community.</h6>
        <Row className='align-items-center'>
            <Col lg={6} className='mb-3'>
                <img src={img4} alt="location" className='img-fluid'></img>
            </Col>
            <Col lg={6} className='position-relative d-flex align-tems-center justify-content-center'>
                <img src={isMobile ? "/locationm.png" :"/location.png"} alt="location" className='img-fluid'></img>
            </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Location
